import { render, staticRenderFns } from "./SettingData.vue?vue&type=template&id=7e5898ea&scoped=true"
import script from "./SettingData.vue?vue&type=script&lang=js"
export * from "./SettingData.vue?vue&type=script&lang=js"
import style0 from "./SettingData.vue?vue&type=style&index=0&id=7e5898ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e5898ea",
  null
  
)

export default component.exports